import Fight from '@/interfaces/Fight';
import Fighter from '@/interfaces/Fighter';
import { Person } from '@/interfaces/Person';

export default class Migrator {

  public static migratePerson(person: Person) {
    if (!person.hasOwnProperty('source')) {
      person.source = 'world';
    }
    return person;
  }

  public migrateFight(fight: Fight) {
    if (fight === null || fight.fighters === null) {
      return fight;
    }
    // Migrate all the fighters
    fight.fighters.forEach((fighter) => {
      if (!fighter.hasOwnProperty('sequenceValue')) {
        fighter.sequenceValue = fighter.initiative;
      }
    });

    return fight;
  }

  public migrateFighter(fighter: Fighter) {
    if (!fighter.hasOwnProperty('sequenceValue')) {
      fighter.sequenceValue = fighter.initiative;
    }

    if (!fighter.hasOwnProperty('done')) {
      fighter.done = false;
    }
    return fighter;
  }
}
